// src/services/authService.js
import api from './api';

const authService = {
  /**
   * User signup
   /**
   * Step 1: Request OTP
   */
  signup: async (userData) => {
    // This hits @PostMapping("/signup") which returns a String message
    const response = await api.post('/auth/signup', userData);
    
    // CRITICAL: We DO NOT save anything to localStorage here.
    // The user is not yet verified or created in the DB.
    return response.data;
  },

  /**
   * Step 2: Finalize Registration with OTP
   * @param {Object} otpData - { otp, signupData: { fullName, email, password } }
   */
  verifyOtp: async (otpData) => {
    // This hits @PostMapping("/verify-otp") which returns the AuthResponse
    const response = await api.post('/auth/verify-otp', otpData);
    
    // NOW we save the token and user because the registration is finished
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify({
        id: response.data.id,
        email: response.data.email,
        fullName: response.data.fullName,
        role: response.data.role,
      }));
    }
    
    return response.data;
  },

  /**
   * User login
   * @param {Object} credentials - { email, password }
   * @returns {Promise} Response with token and user data
   */
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    
    // Save token and user data to localStorage
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify({
        id: response.data.id,
        email: response.data.email,
        fullName: response.data.fullName,
        role: response.data.role,
      }));
    }
    
    return response.data;
  },

  /**
   * User logout
   */
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  },

  /**
   * Get current user from localStorage
   * @returns {Object|null} User object or null
   */
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  /**
   * Check if user is authenticated
   * @returns {boolean}
   */
  isAuthenticated: () => {
    const token = localStorage.getItem('token');
    return !!token;
  },

  /**
   * Get auth token
   * @returns {string|null}
   */
  getToken: () => {
    return localStorage.getItem('token');
  },
};

export default authService;